<template>
  <nav class="header">
    <div class="container">
      <div class="left">
        <img
          src="https://images.avishkaar.cc/workflow/hp_v1/Avishkaar_Logo.png"
          alt="Avishkaar"
          class="logo"
          height="100%"
        />
        <!-- display map of events from page 1 -->
        <div v-if="page>0" class="one-two d-none d-md-flex">
          <div class="one box">
            <span :class="[page>3 ? 'done' : 'enabled', 'number']">
              <span v-if="page>3">
                <!-- tick mark -->
                <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M4.21493 8.13903C3.86535 8.2891 3.44452 8.21087 3.17335 7.91423L0.907855 5.43592C0.565183 5.06106 0.591278 4.47939 0.966139 4.13671C1.341 3.79404 1.92268 3.82013 2.26535 4.19499L3.91058 5.99477L9.79369 0.61684C10.1685 0.274167 10.7502 0.300262 11.0929 0.675123C11.4356 1.04998 11.4095 1.63166 11.0346 1.97433L4.4734 7.97215C4.39494 8.04387 4.30742 8.09944 4.21493 8.13903Z" fill="white"/>
                </svg>
              </span>
              <span v-else>1</span>
            </span>
            <span class="text">
              Delivery Information
            </span>
          </div>
          <div class="two box">
            <span :class="[page>3 ? 'enabled' : 'disabled', 'number']">
              2
            </span>
            <span class="text">
              Review &amp; Pay
            </span>
          </div>
        </div>
      </div>
      <!-- display name only if available -->
      <div style="font-size: 14px; color: #303030;" v-if="name!==''">
        Welcome, {{ name }}!
      </div>
    </div>
  </nav>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Header",
  data() {
    return {
      user: undefined,
    }
  },
  props: {
    page: Number,
    name: String,
  },
  computed: {
    ...mapGetters({
    userDetails: "getUserDetails"
    }),
  },
  methods: {
    ...mapActions([
      "fetchUserDetails",
    ]),
  },
  created() {
    if (this.$cookies.get("userAccess") !== null) {
      this.fetchUserDetails();
    }
    // .then(data => console.log(data))
  },
  watch: {
    userDetails: function() {
      // console.log(this.userDetails);
      this.$emit('user-details', this.userDetails);
    }
  }
}
</script>

<style scoped>
  .header {
    position: fixed;
    z-index: 2;
    top: 0;
    left: 0;
    width: 100vw;
    height: 64px;
    background: #FFFFFF;
    box-shadow: -8px 8px 25px rgba(0, 0, 0, 0.09);

  }
  .header > .container {
    height: 64px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .header > .container > .left {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .header > .container > .left > img {
    height: 36px;
  }

  .one-two {
    margin-left: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  /* line between 2 contents of numbered events */
  .one-two::before {
    content: '';
    position: absolute;
    top: 12px;
    left: 95px;
    width: 110px;
    height: 10px;
    border-top: solid 2px #e0e0e0;
  }
  /* ---- */

  .one-two > .box {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 14px;
    width: 150px;
  }
  .one-two > .box > .number {
    border-radius: 1000px;
    color: #fff;
    height: 24px;
    width: 24px;
    margin-bottom: 5px;

    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .one-two > .box > .number.enabled {
    background: #f46f2e;
  }
  .one-two > .box > .number.enabled ~ .text {
    color: #f46f2e;
  }
  
  .one-two > .box > .number.disabled {
    background: #c0c0c0;
  }
  .one-two > .box > .number.done {
    background: #9FC349;
  }
  .one-two > .box > .number.disabled ~ .text,
  .one-two > .box > .number.done ~ .text {
    color: #909090;
  }
</style>